// src/rust/RustApp.js
import React, { useState, useEffect } from 'react';
import useDynamicMeta from '../hooks/useDynamicMeta';
import Navbar from './Navbar';
import Top from './Top';
import AndroidMobileVersion from './AndroidMobileVersion';
import Features from './Features';
import InfoBlocks from './InfoBlocks';
import Reviews from './Reviews';
import Pricing from './Pricing';
import Dashboard from './Dashboard';
import Footer from './Footer';
import ToS from './ToS';
import './App.css';

// Gibt für jede Hash-Route Titel, Description und Social‑Image zurück
function getMetaForHash(hash) {
  switch (hash) {
    case '#dashboard':
      return {
        title: 'EAGLE SCRIPT - Your Dashboard',
        description: 'Your personal dashboard for managing EAGLE SCRIPT settings and updates.',
        image: window.location.origin + '/preview-dashboard.png',
      };
    default:
      return {
        title: 'Rust Script | Undetected Rust No Recoil Script',
        description:
          'Boost your Rust gameplay with EAGLE SCRIPT – the undetected no‑recoil solution: 100% secure, fully customizable, cloud hotkeys, Anti‑AFK, frequent updates & 24/7 Discord support.',
        image: window.location.origin + '/social-preview.png',
      };
  }
}

function RustApp() {
  const [hash, setHash] = useState(window.location.hash || '');

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    
    // Füge rust-page Klasse zum html Element hinzu
    document.documentElement.classList.add('rust-page');
    
    // Stelle sicher, dass Standard-Favicon verwendet wird
    const changeFavicon = (href) => {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = href;
      document.getElementsByTagName('head')[0].appendChild(link);
    };
    
    changeFavicon('/favicon.ico');
    
    return () => {
      window.removeEventListener('hashchange', onHashChange);
      // Entferne rust-page Klasse beim Unmounting
      document.documentElement.classList.remove('rust-page');
    };
  }, []);

  const { title, description, image } = getMetaForHash(hash);
  const canonicalUrl =
    window.location.origin + window.location.pathname + (hash || '');
  useDynamicMeta({ title, description, canonicalUrl, image });

  return (
    <div className="App rust-app">
      {hash !== '#dashboard' && hash !== '#Tos' && <Navbar />}

      {hash === '#dashboard' ? (
        <Dashboard />
      ) : hash === '#Tos' ? (
        <ToS />
      ) : (
        <>
          <div className="top-wrapper">
            <div className="top-shadow" />
            <Top />
          </div>
          <Features />
          <AndroidMobileVersion />
          <InfoBlocks />
          <Reviews />
          <Pricing />
        </>
      )}

      {hash !== '#dashboard' && hash !== '#Tos' && <Footer />}
    </div>
  );
}

export default RustApp;